module.exports = __webpack_public_path__ + "static/img/5767_phase_function_Paper_Points.04fd8ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5767_phase_function_Paper_Points.png
// module id = 4Hir
// module chunks = 0